import { hashTarget, jumpTo, unmodifiedActivation } from './anchors';

/* Accessibility Updates. */
// Preserve nested link markup and avoid repeating notices already rendered by a block.
const linkNotices = [
    ['a[href$=".pdf" i]', '(opens PDF)', /\bPDF\b/i],
    ['a[href^="mailto:"]', '(opens default email app)', /opens (?:default |your )?email(?: app)?/i],
    ['a[href^="tel:"]', '(opens telephone link)', /opens telephone link/i],
    ['a[target="_blank"]', '(opens in a new tab)', /opens? in (?:a )?new (?:tab|window)/i],
];
linkNotices.forEach(([selector, notice, alreadyDescribed]) => {
    document.querySelectorAll(selector).forEach(link => {
        const label = link.getAttribute('aria-label');
        if (alreadyDescribed.test(`${label || ''} ${link.textContent}`)) return;
        if (label) {
            link.setAttribute('aria-label', `${label} ${notice}`);
        } else {
            const description = document.createElement('span');
            description.className = 'sr-only';
            description.textContent = ` ${notice}`;
            link.append(description);
        }
    });
});



document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.skip-link, .coto-skip-page-links').forEach(link => {
        link.addEventListener('click', event => {
            if (!unmodifiedActivation(event)) return;
            const target = hashTarget(link.hash);
            if (!target) return;
            event.preventDefault();
            jumpTo(target, { keyboard: true });
        });
    });
});
